import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {

  constructor(
    private apiConfig: ApiConfig,
    private HELPER: HelperService,
  ) {}

  init(frLoc?: string): void {
    // tslint:disable
    const cookieConsent = this.apiConfig.config.cookieConsent;
    if (!cookieConsent) {
      return;
    }
    const { src, domainScript } = cookieConsent;
    console.log(src, domainScript);

    const openComment = document.createComment('OneTrust Cookies Consent Notice start for ias.deloitte.com');
    const closeComment = document.createComment('OneTrust Cookies Consent Notice end for ias.deloitte.com');
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.defer = true;
    script.charset = 'UTF-8';
    script.src = src;
    script.dataset['domainScript'] = location.host.includes('iasplus.com')
      ? domainScript.replace('-test', '')
      : domainScript;

    script.dataset['language'] = frLoc || this.HELPER.getFrLocFromUrl() || 'en';
    const script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.defer = true;
    script2.innerHTML = `function OptanonWrapper() {}`;

    document.head.appendChild(openComment);
    document.head.appendChild(script);
    document.head.appendChild(script2);
    document.head.appendChild(closeComment);
  }
}
